import React from 'react';
import { Link } from 'react-router-dom';
import { PHONE_DISPLAY, PHONE_TEL } from '../constants/brand';
import { ROUTES } from '../enum/routes';

export default function CtaBand({
  title,
  lead,
}: {
  title: string;
  lead: string;
}) {
  return (
    <section className="bg-forest py-16 text-white sm:py-20">
      <div className="container-page text-center">
        <h2 className="font-serif text-3xl tracking-tight sm:text-4xl md:text-5xl">{title}</h2>
        <p className="mx-auto mt-4 max-w-2xl text-base text-white/85 sm:text-lg">{lead}</p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            className="inline-flex items-center justify-center rounded-md bg-white px-6 py-3 text-base font-semibold text-forest transition-colors hover:bg-forest-tint"
            to={ROUTES.QUOTE}
          >
            Get Your Free Quote
          </Link>
          <a
            href={`tel:${PHONE_TEL}`}
            className="inline-flex items-center justify-center rounded-md border border-white/40 px-6 py-3 text-base font-semibold text-white transition-colors hover:bg-white hover:text-forest"
          >
            Call {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </section>
  );
}
